import {z} from 'zod'

export const Admin = z.object({
    first_name: z.string(),
    id: z.number().int().positive(),
    last_name: z.string()
})

export const FreelancerStatus = z.enum(['active_available', 'active_unavailable', 'suspended', 'deactivated'])
export type FreelancerStatus = z.infer<typeof FreelancerStatus>

export const Freelancer = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    airbnb_user_id: z.string(),
    status: FreelancerStatus,
    in_progress_assignments_count: z.number(),
    deactivation_reason: z.string().nullable(),
    suspension_reason: z.string().nullable()
})

export type Freelancer = z.infer<typeof Freelancer>
